export function setCookie(name: string, value: string, expiryDays: number): void {
    const d = new Date();
    d.setTime(d.getTime() + (expiryDays*24*60*60*1000));
    const expires = `expires=${d.toUTCString()}`;
    const domain = `domain= ${window.location.hostname}`;
    const path = 'path=/';
    document.cookie = `${name}=${value}; ${expires}; ${domain}; ${path}`;
}

export function setSessionCookie(name: string, value: string): void {
    const domain = `domain= ${window.location.hostname}`;
    const path = 'path=/';
    document.cookie = `${name}=${value}; ${domain}; ${path}`;
}

export function deleteCookie(name: string): void {
    document.cookie = `${name}=; Max-Age=0; path=/; domain=${window.location.hostname}`;
}

export function getCookieValue(cookieName: string): string | undefined {
    if (document.cookie) {
        const key: string = `${cookieName}=`;
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];

            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }

            if (cookie.indexOf(key) === 0) {
                return cookie.substring(key.length, cookie.length);
            }
        }
    }

    return undefined;
}
